import { render, staticRenderFns } from "./ListPrice.vue?vue&type=template&id=0083cc28"
import script from "./ListPrice.vue?vue&type=script&lang=js"
export * from "./ListPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports